export default "/images/phone.svg?bb97df75f043d8ec60cba970a3500234";